import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/edit.svg'
import _imports_1 from '@/assets/icons/trash.svg'
import _imports_2 from '@/assets/icons/close.svg'


const _hoisted_1 = { class: "optional-upgrades-view" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title-section" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 1,
  class: "upgrades-table"
}
const _hoisted_8 = { class: "title-cell" }
const _hoisted_9 = { class: "desc-cell" }
const _hoisted_10 = { class: "price-cell" }
const _hoisted_11 = { class: "image-cell" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "no-image"
}
const _hoisted_14 = { class: "actions" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "spinner"
}
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "image-upload-area" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "image-placeholder"
}
const _hoisted_29 = { class: "image-upload-controls" }
const _hoisted_30 = { class: "modal-actions" }
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "title-main" }, "Optional Upgrades", -1)),
          (!$setup.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.upgrades.length) + " upgrade" + _toDisplayString($setup.upgrades.length !== 1 ? "s" : ""), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "button default primary",
          onClick: $setup.openCreateModal
        }, "+ Create Upgrade")
      ]),
      (!$setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            ($setup.upgrades.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("p", null, "No optional upgrades found for this estate", -1),
                  _createElementVNode("p", { class: "hint" }, "Create the first optional upgrade to get started", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("table", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Title"),
                      _createElementVNode("th", null, "Description"),
                      _createElementVNode("th", null, "Price"),
                      _createElementVNode("th", null, "Image"),
                      _createElementVNode("th", null, "Actions")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upgrades, (upgrade) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: upgrade._id
                      }, [
                        _createElementVNode("td", _hoisted_8, _toDisplayString(upgrade.name), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(upgrade.description || "—"), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString($setup.formatPrice(upgrade.price)), 1),
                        _createElementVNode("td", _hoisted_11, [
                          (upgrade.url)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "upgrade-thumb",
                                src: upgrade.url,
                                alt: "Upgrade image"
                              }, null, 8, _hoisted_12))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, "—"))
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("img", {
                            class: "icon-action",
                            src: _imports_0,
                            onClick: ($event: any) => ($setup.openEditModal(upgrade)),
                            alt: "Edit"
                          }, null, 8, _hoisted_15),
                          _createElementVNode("img", {
                            class: "icon-action",
                            src: _imports_1,
                            onClick: ($event: any) => ($setup.confirmDelete(upgrade)),
                            alt: "Delete"
                          }, null, 8, _hoisted_16)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
          ]))
        : _createCommentVNode("", true),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
        : _createCommentVNode("", true)
    ]),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _withModifiers($setup.closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h3", null, _toDisplayString($setup.isEditMode ? "Edit" : "Create") + " Optional Upgrade", 1),
              _createElementVNode("img", {
                class: "close-icon",
                src: _imports_2,
                onClick: $setup.closeModal,
                alt: "Close"
              })
            ]),
            _createElementVNode("form", {
              class: "modal-form",
              onSubmit: _withModifiers($setup.saveUpgrade, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_20, [
                _cache[7] || (_cache[7] = _createElementVNode("label", null, "Title *", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.nameError }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event)),
                  placeholder: "e.g. Ducted Air Conditioning"
                }, null, 2), [
                  [_vModelText, $setup.form.name]
                ]),
                ($setup.nameError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Title is required"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[8] || (_cache[8] = _createElementVNode("label", null, "Description", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "input textarea",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.description) = $event)),
                  placeholder: "Describe what this upgrade includes...",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, $setup.form.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[9] || (_cache[9] = _createElementVNode("label", null, "Price *", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.priceError }]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.price) = $event)),
                  type: "number",
                  min: "0",
                  placeholder: "e.g. 5000"
                }, null, 2), [
                  [
                    _vModelText,
                    $setup.form.price,
                    void 0,
                    { number: true }
                  ]
                ]),
                ($setup.priceError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Price is required"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Image", -1)),
                _createElementVNode("div", _hoisted_26, [
                  ($setup.imagePreviewUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "image-preview",
                        src: $setup.imagePreviewUrl,
                        alt: "Preview"
                      }, null, 8, _hoisted_27))
                    : (_openBlock(), _createElementBlock("div", _hoisted_28, "No image selected")),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("input", {
                      class: "file-input",
                      ref: "fileInputRef",
                      type: "file",
                      accept: "image/*",
                      onChange: $setup.onFileSelected
                    }, null, 544),
                    _createElementVNode("button", {
                      class: "upload-btn",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.fileInputRef?.click()))
                    }, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "upload-btn-icon" }, "↑", -1)),
                      _createTextVNode(_toDisplayString($setup.imagePreviewUrl ? "Change Image" : "Upload Image"), 1)
                    ]),
                    ($setup.imagePreviewUrl)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "remove-btn",
                          type: "button",
                          onClick: $setup.clearImage
                        }, "Remove"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "button default cancel",
                  type: "button",
                  onClick: $setup.closeModal
                }, "Cancel"),
                _createElementVNode("button", {
                  class: "button default primary",
                  type: "submit",
                  disabled: $setup.saving
                }, _toDisplayString($setup.saving ? "Saving..." : $setup.isEditMode ? "Save Changes" : "Create Upgrade"), 9, _hoisted_31)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}